import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import { Provider } from 'react-redux';
import ScrollToTop from 'components/ScrollToTop';
import store, { history } from 'utils/store';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { grey, indigo, pink } from '@mui/material/colors';
import PromoPage from 'components/pages/PromoPage';

class App extends React.Component {
  getTheme() {
    return createTheme({
      palette: {
        primary: {main: window.THEME_PRIMARY_COLOUR ? '#' + window.THEME_PRIMARY_COLOUR : indigo[500]},
        'button-grey': {main: grey[300]}
      },
      typography: {
        fontFamily: window.CUSTOM_FONT
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              '&.Mui-focusVisible': {
                outline: window.VISIBLE_FOCUS_COLOUR ? '#' + window.VISIBLE_FOCUS_COLOUR : pink[400],
                outlineStyle: 'solid',
                outlineWidth: '2px'
              },
              '.MuiTouchRipple-root': {
                display: 'none'
              }
            }
          }
        },
        MuiStepIcon: {
          styleOverrides: {
            root: {
              '&:not(.Mui-active)': {
                text: {
                  fill: 'black' // Overrides inactive step icon text colour for accessibility contrast
                }
              }
            }
          }
        }
      }
    })
  }

  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <ThemeProvider theme={this.getTheme()}>
            <div>
              <ScrollToTop>
                <PromoPage />
              </ScrollToTop>
            </div>
          </ThemeProvider>
        </ConnectedRouter>
      </Provider>
    )
  }
}

export default App;
